module.exports = __webpack_public_path__ + "static/media/modis2941.055fbfc0.jpg";